import { offerings } from "../../../data/offerings";
import styles from "./TrustStrip.module.css";

const icon = {
  pulse: <path d="M3 12h4l2.5-6 4 12 2.5-6H21" />,
  box: (
    <>
      <path d="M4 7.5 12 3l8 4.5v9L12 21l-8-4.5Z" />
      <path d="M4 7.5 12 12l8-4.5M12 12v9" />
    </>
  ),
  pin: (
    <>
      <path d="M12 21s7-6 7-12a7 7 0 1 0-14 0c0 6 7 12 7 12Z" />
      <circle cx="12" cy="9" r="2.4" />
    </>
  ),
  code: <path d="M8 7 3 12l5 5M16 7l5 5-5 5M13.5 4 10.5 20" />,
};

function Icon({ name }) {
  return (
    <svg
      viewBox="0 0 24 24"
      width="22"
      height="22"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.9"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      {icon[name]}
    </svg>
  );
}

export default function TrustStrip() {
  return (
    <aside id="what-we-offer" className={styles.strip} aria-label="What we offer" data-reveal="">
      <div className={`container ${styles.inner}`}>
        {offerings.map((group) => (
          <div key={group.label} className={styles.group}>
            <span className={styles.label}>{group.label}</span>
            <ul className={styles.tags}>
              {group.items.map((item) => (
                <li key={item.text}>
                  <a className={styles.tag} href={item.href}>
                    <span className={styles.tagIcon}>
                      <Icon name={item.icon} />
                    </span>
                    <span className={styles.tagBody}>
                      <span className={styles.tagTitle}>{item.text}</span>
                      <span className={styles.tagDesc}>{item.desc}</span>
                    </span>
                  </a>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </aside>
  );
}
